import Axios from 'axios' 
import {
  SYSUSERROLEDET_UNSET_ALL_STATE,
  SYSUSERROLEDET_SET_MSG,
  SYSUSERROLEDET_UNSET_MSG,
  SYSUSERROLEDET_SET_SCHEMA,
  SYSUSERROLEDET_UNSET_SCHEMA,
  SYSUSERROLEDET_SET_ACTION_PROCESS,
  SYSUSERROLEDET_UNSET_ACTION_PROCESS,
  SYSUSERROLEDET_SET_LIST_DATA, 
  SYSUSERROLEDET_UNSET_LIST_DATA,
  SYSUSERROLEDET_SET_ACTION_STATUS,
  SYSUSERROLEDET_UNSET_ACTION_STATUS

} from '../mutation-types'

const state = {     
  dataList: [],   
  message: '',
  actionStatus:false, 
  actionProcess:false, 
  Schema:{ 
    read: '',
    save: '',
    update: '',
    delete: '',
    active: 1,
    role_det_id: 0,
    role_id: '',
    submenu_id: '',
    login_id: '',
    id:0
  }
}

const getters = {
  get_SYSUSERROLEDET_DataList (state) {
    return state.dataList ;
  }, 
  get_SYSUSERROLEDET_ActionMessage(state){
    return state.message ;
  },
  get_SYSUSERROLEDET_Schema(state){
    return state.Schema
  },
  get_SYSUSERROLEDET_ActionProcess(state){
    return state.actionProcess ;
  },
  get_SYSUSERROLEDET_ActionStatus(state){
    return state.actionStatus ;
  },

}

// mutations

const	mutations = {	
  [SYSUSERROLEDET_UNSET_ALL_STATE] (state){
    state.actionProcess = false,
    state.dataList = [],      
    state.Schema = {
      read: '',
      save: '',
      update: '',
      delete: '',
      active: 1,
      role_id: '',
      submenu_id: '',
      login_id: '',
      id:0
    }  
  },
  [SYSUSERROLEDET_SET_ACTION_STATUS](state){
    state.actionStatus = true
  },
  [SYSUSERROLEDET_UNSET_ACTION_STATUS](state){
    state.actionStatus = false
  },
  [SYSUSERROLEDET_SET_MSG](state,msg){
    state.message = msg
  },
  [SYSUSERROLEDET_UNSET_MSG](state){
    state.message = ""
  },
  [SYSUSERROLEDET_UNSET_ACTION_PROCESS]( state ){ 
    state.actionProcess = false
  },
  [SYSUSERROLEDET_SET_ACTION_PROCESS]( state ){
    state.actionProcess = true 
  },
  [SYSUSERROLEDET_SET_LIST_DATA](state,itemList){
    state.dataList = itemList 
  },
  [SYSUSERROLEDET_UNSET_LIST_DATA](state){
    state.dataList = [] 
  },
  [SYSUSERROLEDET_SET_SCHEMA](state,schemaData){
    state.Schema = schemaData 
  },
  [SYSUSERROLEDET_UNSET_SCHEMA](state){
    state.Schema = [] 
    state.Schema.active =1
  },
}

// Actions

const actions = {
	
}
export default {
 state,
 getters,
 actions,
 mutations
}



// WEBPACK FOOTER //
// ./src/vuex/module/dia_sysUserroleDet_module.js